import * as React from "react";
import Ratio from "react-bootstrap/Ratio";

const Video = ({ videoData }) => {
  const { id, statistics } = videoData.items[0];
  const { viewCount, likeCount, dislikeCount } = statistics;
  return (
    <div className="video-embed">
      {videoData ? (
        <>
          <Ratio aspectRatio="16x9">
            <iframe
              title="Embeded YouTube video"
              className="embed-responsive-item"
              src={"https://www.youtube.com/embed/" + id}
              allowFullScreen
            />
          </Ratio>

          <div className="video-info">
            <span id="video-views" className="text-muted">
              {viewCount} views
            </span>

            <span className="social">
              <i className="fa fa-thumbs-o-up" aria-label="likes" />

              <span id="video-likes">{likeCount}</span>

              <i className="fa fa-thumbs-o-down" aria-label="dislikes" />
              <span id="video-dislikes">{dislikeCount}</span>
            </span>
          </div>
        </>
      ) : (
        <h2>Loading...</h2>
      )}
    </div>
  );
};

export default Video;
